import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import './TerminalVisitLaycan.scss'
import { ViewerItem, MOVE_NONE } from '@teqplay/viewer'

export default class TerminalVisitLaycan extends PureComponent {
  static propTypes = {
    terminalVisit: PropTypes.object.isRequired,
    order: PropTypes.object.isRequired,
    timeToScreen: PropTypes.func.isRequired,
    bollardToScreen: PropTypes.func.isRequired
  }

  render() {
    const terminalVisitLaycanDetails = this.convertTerminalVisitLaycan()
    const { xStart, xEnd, yStart, yEnd } = terminalVisitLaycanDetails

    // laycanStart and laycanEnd not required when creating Terminal Visit
    if (xStart && xEnd && yStart && yEnd) {
      return (
        <ViewerItem
          item={terminalVisitLaycanDetails}
          movement={MOVE_NONE}
          yUnitToScreen={this.props.timeToScreen}
          xUnitToScreen={this.props.bollardToScreen}
          className="terminal-visit-laycan"
        />
      )
    }
    return null
  }

  convertTerminalVisitLaycan = () => {
    const cargoStartTime = this.props.order.cargoStart
    const cargoEndTime = this.props.order.cargoEnd
    const ataTime = this.props.terminalVisit.ataTime
    const atdTime = this.props.terminalVisit.atdTime

    if (ataTime) {
      // The visit has completed, hide the slacktimes and set visitIscompleted to true
      if (atdTime) {
        // use ata and atd time
        return {
          xStart: this.props.order.bollardStart,
          xEnd: this.props.order.bollardEnd,
          yStart: new Date(ataTime),
          yEnd: new Date(atdTime)
        }

        // the ata time is before the cargo end time
      } else if (ataTime <= cargoEndTime) {
        // use ata and cargoEndTime
        return {
          xStart: this.props.order.bollardStart,
          xEnd: this.props.order.bollardEnd,
          yStart: new Date(ataTime),
          yEnd: new Date(cargoEndTime)
        }
      } else if (ataTime > cargoEndTime) {
        const calculatedEndTime = ataTime + (cargoEndTime - cargoStartTime)

        // use ata and the calculatedEndTime
        return {
          xStart: this.props.order.bollardStart,
          xEnd: this.props.order.bollardEnd,
          yStart: new Date(ataTime),
          yEnd: new Date(calculatedEndTime)
        }
      }
    }

    return {
      xStart: this.props.order.bollardStart,
      xEnd: this.props.order.bollardEnd,
      // expects date fields to be validated when creating order
      yStart: isNaN(this.props.order.laycanStart) ? null : new Date(this.props.order.laycanStart),
      yEnd: isNaN(this.props.order.laycanEnd) ? null : new Date(this.props.order.laycanEnd)
    }
  }
}
